import { Component, NgZone, OnInit, isDevMode } from '@angular/core';
import { SpinnerService } from './services/spinner/spinner.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, tap } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

declare global {
  interface Window {
    // Web3: any;
    ethereum: any;
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title: string = 'trainer-hub';
  showSpinner: boolean = false;
  isDialogRefreshOpen: boolean = false;

  // showSpinner$: Observable<boolean>;

  constructor(
    private spinnerService: SpinnerService,
    private ngZone: NgZone,
    private swUpdate: SwUpdate
  ) {
  }

  ngOnInit(): void {

    // this.showSpinner$ = this.spinnerService.showSpinner$
    this.spinnerService.showSpinner$.subscribe(v => {
      setTimeout(() => {
        // this.showSpinner = v
        // console.log(' this.showSpinner', this.showSpinner)
        this.ngZone.run(() => this.showSpinner = v);
      });
    });
    //check for new deploy version
    if (this.swUpdate.isEnabled) {
      this.checkVersion();
    }
  }

  checkVersion() {
    this.swUpdate.checkForUpdate().then(() => { }); //maybe not necessary
    this.swUpdate.versionUpdates
      .pipe(
        tap(evt => console.log('PWA STATUS', evt)),
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(evt => {
        this.isDialogRefreshOpen = true;
      });
  }

}
